import React, { useContext, useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Row,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  FaUserAlt,
  FaLock,
  FaShieldAlt,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import { isEmpty } from "lodash";
import { Helmet } from "react-helmet";
import { IoIosArrowBack } from "react-icons/io";
import loginImg from "../assets/images/login-img.png";
const LoginNew = () => {
  const navigate = useNavigate();
  let { loginUser, user } = useContext(AuthContext);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const [showPassword, setShowPassword] = useState(true);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    unregister,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  const [getValidateCode, setValidateCode] = useState("");

  const onSubmit = (data) => {
    if (parseInt(data.validateCode) === parseInt(getValidateCode)) {
      loginUser(data);
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      navigate("/");
    }
  }, [user]);


  useEffect(() => {
    changeCode();

  }, []);

  const canvasRef = useRef(null);

  //   const [canvaData, setCanvaData] = useState("Hello wordl");

  const changeCode = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    context.font = "bold 120px sans-serif";
    const code = Math.floor(1000 + Math.random() * 9000);
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillText(code, 0, 130);
    setValidateCode(code);
  };

  return (
    <div className="login">
      <Helmet>
              <meta
                name="viewport"
                content="width=device-width, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no"
              />
            </Helmet>
      <Container className="h-100 align-middle">
        <Row className="h-100 align-items-center align-middle justify-content-center">
          <Col md={11}>
            <Row>
              <Col md={7} className="text-start">
                <img
                  data-aos="zoom-in-down"
                  src={loginImg}
                  style={{ width: "80%" }}
                />
              </Col>
              <Col md={5}>
                <div data-aos="flip-up" className="text-center mt-5 mb-4">
                   <img src="./assets/images/logo.png" style={{ width: "220px" }} />
                </div>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <div data-aos="zoom-in" className="loginForm">
                    <div style={{color:"black"}} className="d-flex flex-column align-items-center mb-4">
                      <h5 className="m-0">Welcome</h5>
                      <span>Login in to you account to continue</span>
                    </div>
                    <Form.Label>Username</Form.Label>{" "}
                    <Form.Group className="mb-2">
                      <Form.Control
                        type="text"
                        placeholder="Username"
                        className={errors.username ? "is-invalid" : ""}
                        {...register("username", {
                          required: "Please enter Username",
                        })}
                        id="username"
                      />{" "}
                      {errors.username && errors.username.message && (
                        <label className="invalid-feedback text-left">
                          {errors.username.message}
                        </label>
                      )}
                    </Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Group className="mb-2 position-relative">
                      <Form.Control
                        type={!showPassword ? "text" : "password"}
                        placeholder="Password"
                        maxLength={15}
                        {...register("password", {
                          required: "Please enter password",
                        })}
                        className={errors.password ? "is-invalid" : ""}
                      />
                      <button
                        type="button"
                        className="position-absolute translate-middle-y top-50 end-0 me-2 bg-transparent border-0 text-dark p-0 "
                        onClick={() => handleShow()}
                      >
                        {!showPassword ? (
                          <FaEye className="opacity-100 fs-5" size="17" />
                        ) : (
                          <FaEyeSlash className="opacity-100 fs-5" size="17" />
                        )}
                      </button>
                      {/* </FloatingLabel> */}
                      {errors.password && errors.password.message && (
                        <label className="invalid-feedback text-left">
                          {errors.password.message}
                        </label>
                      )}
                    </Form.Group>
                    <Form.Label>ValidationCode</Form.Label>
                    <Form.Group className="mb-2 position-relative">
                      <Form.Control
                        type="number"
                        keyboardType="numeric"
                        autocomplete="off"
                        className={`login-input ${
                          !isEmpty(watch("validateCode"))
                            ? "login-input-border"
                            : ""
                        }`}
                        maxLength="4"
                        {...register("validateCode", {
                          required: "Please enter validate code",
                          validate: {
                            validate: (value) =>
                              parseInt(value) === parseInt(getValidateCode) ||
                              "Invalid validate code",
                          },
                        })}
                        style={
                          errors.validateCode
                            ? {
                                borderColor: "red",
                              }
                            : {}
                        }
                        onChange={(e) => {
                          if (e.target.value.length == 4) {
                            e.target.blur();
                            unregister("validateCode", { keepValue: true });
                          }
                        }}
                        placeholder="ValidationCode"
                      />
                      <div
                        style={{ left: "10px" }}
                        className="position-absolute top-0 flex items-center h-40px ml-2 space-x-3px start-icon"
                      >
                        {" "}
                        <span
                          className={`${
                            !isEmpty(watch("validateCode"))
                              ? "icon-content-selected"
                              : ""
                          } position-absolute  translate-middle-y top-50 icon-content text-18 text-black-400 top-3 left-3 z-10 icon-shield`}
                        >
                          <i class="icon-flag-bangladesh path1 z-10 text-18"></i>
                        </span>
                      </div>
                      <canvas
                        ref={canvasRef}
                        onClick={changeCode}
                        className="position-absolute translate-middle-y top-50 canvas-img"
                        id="authenticateImage"
                      />
                      {errors.validateCode && errors?.validateCode?.message && (
                        <label className="invalid-feedback text-left">
                          {errors.validateCode.message}
                        </label>
                      )}
                    </Form.Group>
                    {/* <p className="f-password">
                  {" "}
                  <Link
                    to="/ForgotPassword"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Forgot Password?
                  </Link>
                </p> */}
                    <Button type="submit" variant="primary">
                      Login
                    </Button>
                    {/* <div
                    onClick={() =>
                      loginUser({
                        username: "demo",
                        password: "demo",
                        uniqueId: Math.random() * 10000,
                      })
                    }
                    style={{
                      paddingTop: "5px",
                      color: "rgb(0, 175, 239)",
                      fontSize: "15px",
                      cursor: "pointer",
                    }}
                  >
                    Login as Demo
                  </div> */}
                  </div>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginNew;
